import { MenuItem } from '@mui/material';
import { default as Box } from '@mui/material/Box';
import { useFormikContext } from 'formik';
import { AppAutocompleteField, AppSelectField } from 'components/form-fields';
import { getTrans } from 'modules/i18n';
import { CVBuilderFormValues } from 'utils/cv-form-db';
import { useHealthInsuranceNames } from './hooks';
import { HealthInsurance } from './types';

export const InsuranceFields = () => {
  const { values } = useFormikContext<CVBuilderFormValues>();
  const { data: healthInsurances } = useHealthInsuranceNames(
    values?.personalDetails.insuranceType
  );

  return (
    <>
      <AppSelectField
        data-dd-privacy="mask"
        name="personalDetails.insuranceType"
        label={getTrans(
          'cvBuilderPage.personalDetails.form.insuranceType.label'
        )}
        variant="outlined"
        fullWidth
        displayValidationError={true}
      >
        <MenuItem value={HealthInsurance.Statutory}>
          {getTrans(
            'cvBuilderPage.personalDetails.form.insuranceType.statutory.label'
          )}
        </MenuItem>
        <MenuItem value={HealthInsurance.Private}>
          {getTrans(
            'cvBuilderPage.personalDetails.form.insuranceType.private.label'
          )}
        </MenuItem>
      </AppSelectField>
      <Box sx={{ pb: 2 }} />
      <AppAutocompleteField
        name="personalDetails.insuranceName"
        label={getTrans(
          'cvBuilderPage.personalDetails.form.insuranceName.label'
        )}
        options={healthInsurances || []}
      />
    </>
  );
};
